import GoogleReviewsOnly from './GoogleReviewsOnly';
import AdvieskeuzeReviews from './AdvieskeuzeReviews';

const GoogleReviews = () => {
  return (
    <>
      <GoogleReviewsOnly />
      <AdvieskeuzeReviews />
    </>
  );
};

export default GoogleReviews;